import { baseApi } from "./apiService";
import {
    CheckoutRequest,
    CheckoutResponse,
    FreeTierUsageResponse,
    PortalRequest,
    PortalResponse,
    PricingResponse,
    SubscriptionStatusResponse,
} from "../types";

export const subscriptionService = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
        getSubscriptionStatus: builder.query<SubscriptionStatusResponse, void>({
            query: () => ({
                url: 'subscription/status',
            }),
            providesTags: ['Subscription'],
        }),

        createCheckoutSession: builder.mutation<CheckoutResponse, CheckoutRequest>({
            query: (body) => ({
                url: 'subscription/checkout',
                method: 'POST',
                body,
            }),
        }),

        createPortalSession: builder.mutation<PortalResponse, PortalRequest>({
            query: (body) => ({
                url: 'subscription/portal',
                method: 'POST',
                body,
            }),
        }),

        cancelSubscription: builder.mutation<{ message: string; cancelAt: string }, void>({
            query: () => ({
                url: 'subscription/cancel',
                method: 'POST',
            }),
            invalidatesTags: ['Subscription'],
        }),

        downgradeToFree: builder.mutation<{ message: string; status: string; planType: string }, void>({
            query: () => ({
                url: 'subscription/downgrade-to-free',
                method: 'POST',
            }),
            invalidatesTags: ['Subscription'],
        }),

        getFreeTierUsage: builder.query<FreeTierUsageResponse, void>({
            query: () => ({
                url: 'subscription/free-tier-usage',
            }),
            providesTags: ['FreeTierUsage'],
        }),

        getPricing: builder.query<PricingResponse, void>({
            query: () => ({
                url: 'subscription/pricing',
            }),
        }),
    }),
});

export const {
    useGetSubscriptionStatusQuery,
    useCreateCheckoutSessionMutation,
    useCreatePortalSessionMutation,
    useCancelSubscriptionMutation,
    useDowngradeToFreeMutation,
    useGetFreeTierUsageQuery,
    useGetPricingQuery,
} = subscriptionService;
